import { rem } from 'polished'
import { useContext } from 'react'
import styled from 'styled-components'

import Group from 'components/utils/Group'
import MapLayersContext from 'tripPlanner/contexts/MapLayers/MapLayersContext'
import FilterChip from 'LuxKit/Chips/FilterChip'

const Container = styled(Group)`
  position: absolute;
  top: ${rem(80)};
  left: ${rem(20)};
`

function ProductLayersChips() {
  const { layerGroups, toggleLayer } = useContext(MapLayersContext)

  const leProductsLayer = layerGroups.find((group) => group.id === 'leProducts')

  if (!leProductsLayer) {
    return null
  }

  return (
    <Container direction="horizontal" gap={8}>
      {leProductsLayer.layers.map((layer) => {
        const Icon = layer.icon
        return <FilterChip
          key={layer.id}
          size="medium"
          selected={layer.isSelected}
          startIcon={Icon ? <Icon /> : undefined}
          onClick={() => toggleLayer(leProductsLayer.id, layer.id)}
        >
          {layer.title}
        </FilterChip>
      })}
    </Container>
  )
}

export default ProductLayersChips
